/**
 * /vozidla/$id/upravit — create-flow continuation only (catalog-seeded
 * vehicles land here from VozidloNovy to finish the record). Not linked from
 * the detail page: edits run through VozidloEditModals on /vozidla/$id.
 */
import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const VozidloUpravit = lazy(() =>
  import('@/modules/vozidla/VozidloUpravit').then((m) => ({ default: m.VozidloUpravit })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/vozidla/$id/upravit',
  component: () => (
    <Suspense fallback={null}>
      <VozidloUpravit />
    </Suspense>
  ),
});
